module.exports = __webpack_public_path__ + "img/ic_32_profile_neuigkeiten.4bd53e46.svg";